// frontend/src/components/ui/badge.jsx
import React from 'react';
import { cn } from '../../lib/utils';

const variantStyles = {
  default: "bg-background-tertiary text-text-primary border border-border-primary",
  secondary: "bg-background-secondary text-text-primary border border-border-primary",
  outline: "border border-border-primary text-text-primary bg-transparent",
  success: "bg-status-success-bg text-status-success-text border border-status-success-border",
  error: "bg-status-error-bg text-status-error-text border border-status-error-border",
  warning: "bg-status-warning-bg text-status-warning-text border border-status-warning-border",
  info: "bg-status-info-bg text-status-info-text border border-status-info-border",
};

export const Badge = ({ variant = "default", className, ...props }) => (
  <span
    className={cn(
      "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
      variantStyles[variant] || variantStyles.default,
      className
    )}
    {...props}
  />
);